export default {
  checkPhone(val) {
    var reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (reg.test(val)) {
      return true;
    }
    return false;
  },
  checkMail(val) {
    var reg = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
    if (reg.test(val)) {
      return true;
    }
    return false;
  },
  checkChineseWord(val) {
    var reg = /[\u4e00-\u9fa5]/;
    if (reg.test(val)) {
      return true;
    }
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/utils/validate.js